export default __webpack_public_path__ + "static/media/expl-gradcam_06_EN.22461d86.png";